import { render, staticRenderFns } from "./AppLang.vue?vue&type=template&id=d6a64ef8&"
import script from "./AppLang.vue?vue&type=script&lang=js&"
export * from "./AppLang.vue?vue&type=script&lang=js&"
import style0 from "./AppLang.vue?vue&type=style&index=0&id=d6a64ef8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports